import addDays from "date-fns/addDays"

export interface CachedSearchParamsType {
  check_in: Date
  check_out: Date
  adult_count: number
  child_count: number
  rate_codes: string[]
  promo_codes: string[]
}

export const cachedSearchParams = (): CachedSearchParamsType | null => {
  if (typeof window === "undefined") return null
  let cached: any = localStorage.getItem("search-params")
  if (cached) {
    cached = JSON.parse(cached)
    cached.rate_codes = [] // Bypass Rate
    cached.promo_codes = [] // Bypass Promo codes
    cached.check_in = cached.check_in ? new Date(cached.check_in) : new Date()
    cached.check_out = cached.check_out
      ? new Date(cached.check_out)
      : addDays(new Date(), 1)

    // Invalidate cache if dates are in the past
    if (cached.check_in < new Date()) {
      return null
    }
  }
  return cached
}

export const cacheSearchParams = (searchParams: CachedSearchParamsType) =>
  localStorage.setItem("search-params", JSON.stringify(searchParams))
